import firebase from "firebase";
import React, { useEffect, useState, createContext } from "react";
import { Badge, Image, Nav, Navbar, NavDropdown } from "react-bootstrap";
import { LinkContainer } from "react-router-bootstrap";
import {
  BrowserRouter as Router, Route, Switch
} from "react-router-dom";

import Auth from './component/auth';
import Home from './component/home';
import IntermediateCoaching from "./component/inter-coach/intermediateCoaching";
import ANULadder from './component/ladder/anuLadder';
import ManageAdmin from "./component/manageAdmin";
import NewUsers from "./component/newUsers";
import ANUPennant from './component/pennant/anuPennant';
import Profile from './component/Profile';
import SignedIn from "./component/signedIn";
import Signout from "./component/signout";

import { db } from "./firebase";
import anutc_logo from './resource/anutc_logo.png';

import './App.css';
import OnPending from "./component/onpending";

import { Avatar } from "@material-ui/core";
import Users from "./component/users";

// MUI v4->v5 migration code

import { createMuiTheme, makeStyles, ThemeProvider } from '@material-ui/core/styles';

const theme = createMuiTheme();

const useStyles = makeStyles((theme) => {
  {
    // some CSS that accesses the theme
  }
});

export const GlobalContext = createContext();


export default function App() {
  var [loggedIn, setLoggedIn] = useState(false)
  var [userName, setUserName] = useState("Not signed in")
  const [photoURL, setphotoURL] = useState(null)
  var [appuser, setappuser] = useState(null)
  let [isAdmin, setisAdmin] = useState(false)
  let [signupReq, setsignupReq] = useState([])

  const pendingDBRef = db.collection("pendings")


  // create the context

  // create a provider component that will wrap the entire application
  const GlobalProvider = ({ children }) => {

    return (
      <GlobalContext.Provider value={[isAdmin, setisAdmin]}>
        {children}
      </GlobalContext.Provider>
    );
  };

  function getSignupReq() {
    pendingDBRef.get()
      .then((querySnapShot) => {
        let respendings = []
        querySnapShot.forEach((ply) => {
          respendings.push(ply)
        })
        setsignupReq(respendings)
      })
      .catch((e) => { console.log(e) })
  }

  useEffect(() => {
    getSignupReq()
  }, [])


  function getAppUser() {
    db.collection("appusers").doc(firebase.auth().currentUser.uid)
      .get()
      .then((doc) => {
        setappuser(doc.data())
      })
      .catch((e) => {
        console.log(e)
      })
  }

  firebase.auth().onAuthStateChanged((firebaseUser) => {
    if (firebaseUser) {
      console.log("User signed in")
      setLoggedIn(true)

      if (!appuser || firebaseUser.uid !== appuser.uid) {
        getAppUser()
      }
    } else {
      console.log("User signed out")
      setLoggedIn(false)
      setUserName("Not signed in")
    }
  })

  // set isAdmin state
  useEffect(() => {
    if (appuser) {
      setUserName(`Hello, ${appuser.displayName}`)
      if (firebase.auth().currentUser) {
        setphotoURL(firebase.auth().currentUser.photoURL)
      }
      if (!appuser.private) {
        setisAdmin(false)
        return
      }
      if (appuser.private.isAdmin || appuser.private.isDev) {
        setisAdmin(true)
      }
      else {
        setisAdmin(false)
      }
    }
    else {
      setisAdmin(false)
    }
    console.log('currentUser', firebase.auth().currentUser)
  }, [appuser])

  const dropdownSignedIn = (
    <div>
      <NavDropdown.Item>
        <LinkContainer to="/profile">
          <Nav.Link>
            {<span className="text-primary my-auto">Profile</span>}
          </Nav.Link>
        </LinkContainer>
      </NavDropdown.Item>

      <NavDropdown.Item>
        <LinkContainer to="/signout" >
          <Nav.Link>
            {<span className="text-primary my-auto">Sign out</span>}
          </Nav.Link>
        </LinkContainer>
      </NavDropdown.Item>
    </div>
  )

  const dropdownSignedOut = (
    <NavDropdown.Item>
      <LinkContainer to="/auth">
        <Nav.Link>
          {<span className="text-primary my-auto">Sign in</span>}
        </Nav.Link>
      </LinkContainer>
    </NavDropdown.Item>
  )

  const adminNavs = (
    <div className="nav-admin inline-block">
      <LinkContainer className="inline-block" to="/users">
        <Nav.Link>Users</Nav.Link>
      </LinkContainer>
      <LinkContainer className="inline-block" to={`/admin/new-users`}>
        <Nav.Link>
          New Users
          {signupReq.length > 0 ?
            <Badge
              pill
              bg="danger"
              style={{ background: "red" }}
            >
              {signupReq.length}
            </Badge>
            :
            null
          }

        </Nav.Link>
      </LinkContainer>
      <LinkContainer className="inline-block" to="/manage-admin">
        <Nav.Link>ManageAdmin</Nav.Link>
      </LinkContainer>
    </div>
  )

  return <ThemeProvider theme={theme}>{
    <GlobalProvider>
      <div className="root">

        <div className="root-body">
          <Router>
            <div
              className="root-container"
              style={{ minWidth: "700px" }}
            >

              <Navbar className="root-navbar" variant="dark">
                <Nav className="" id="root-navbar-nav">
                  <LinkContainer to="/">
                    <Nav.Link>
                      <Image src={anutc_logo} roundedCircle style={{ width: "50px" }} />
                    </Nav.Link>
                  </LinkContainer>

                  <LinkContainer to="/anu-pennant">
                    <Nav.Link>ANU Pennant</Nav.Link>
                  </LinkContainer>

                  <LinkContainer to="/anu-ladder">
                    <Nav.Link>Competition Leaderboard</Nav.Link>
                  </LinkContainer>

                  <LinkContainer to="/intermediate-coaching">
                    <Nav.Link>Intermediate Coaching</Nav.Link>
                  </LinkContainer>

                  {/* <LinkContainer to="/signed-in">
                  <Nav.Link>Signed In</Nav.Link>
                </LinkContainer> */}

                  {isAdmin ? adminNavs : null}

                  <NavDropdown id='nav-dropdown'
                    title={
                      <div className="vertical-center nav-profile" style={{ display: "contents" }}>
                        <Avatar style={{ display: "inline-block" }} src={photoURL}></Avatar>
                        <span className="vertical-center">
                          {userName}
                        </span>
                      </div>
                    }>
                    {loggedIn ? dropdownSignedIn
                      : dropdownSignedOut}
                  </NavDropdown>
                </Nav>
              </Navbar>


              {/* A <Switch> looks through its children <Route>s and
                renders the first one that matches the current URL. */}
              <Switch id='root-content-container'>
                <Route exact path="/anu-pennant">
                  <ANUPennant isAdmin={isAdmin} />
                </Route>
                <Route exact path="/anu-ladder">
                  <ANULadder />
                </Route>
                <Route path="/auth">
                  <Auth />
                </Route>
                <Route path="/on-pending">
                  <OnPending />
                </Route>
                <Route path="/manage-admin">
                  <ManageAdmin />
                </Route>
                <Route path="/users">
                  <Users />
                </Route>
                <Route path="/intermediate-coaching">
                  <IntermediateCoaching isAdmin={isAdmin} />
                </Route>
                <Route exact path='/admin/new-users'>
                  <NewUsers />
                </Route>

                <Route exact path="/signed-in" >
                  <SignedIn></SignedIn>
                </Route>

                <Route path="/profile">
                  <Profile />
                </Route>
                <Route path="/signout">
                  <Signout />
                </Route>

                <Route exact path="/">
                  <Home />
                </Route>
              </Switch>
            </div>
          </Router>
        </div>

        <div class="footer-dark">
          <footer>
            <div class="container">
              <div class="row">
                <div class="col-sm-6 col-md-3 item">
                  <h3>About</h3>
                  <ul>
                    <li><a href="https://www.facebook.com/TennisClubANU">ANUTC Facebook Page</a></li>
                    <li><a href="https://anutennis.org/">ANUTC Website</a></li>
                  </ul>
                </div>
                <div class="col-md-6 item text">
                  <h3>ANU Tennis Club</h3>
                  <p>The ANU Tennis Club is an inclusive and diverse tennis club that accommodates players of all level and ages.</p>
                </div>
              </div>
              <p class="copyright">Copyright © 2021 ANU Tennis Club</p>
            </div>
          </footer>
        </div>


      </div>
    </GlobalProvider>
  }</ThemeProvider>;


}

